<template>
  <div class="h3 text-center mb-6">Завершение регистрации</div>

  <div class="paragraph-s_h mb-6">Для завершения регистрации, пожалуйста, заполните личные данные</div>

  <account-form />
</template>

<script setup lang="ts">
import AccountForm from '@/parts/auth/components/AccountForm.vue';
</script>
